import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";
import moment from "moment";

const InterDistrictTransferPrint = () => {
  const route = useParams().id;
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  const [IDTData, setIDTData] = useState([]);
  const getIDTData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-inter_district_transfer-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === route);
        setIDTData(singleData);
      } else {
        setIDTData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getIDTData();
  }, [userId]);
  const [formData, setFormData] = useState(null);
  const [salarySlip, setSalarySlip] = useState(null);
  useEffect(() => {
    try {
      if (IDTData?.formData) {
        setFormData(JSON.parse(IDTData.formData));
      }
      if (IDTData?.salarySlip) {
        setSalarySlip(JSON.parse(IDTData.salarySlip));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [IDTData]);

  const generatePrintablePage = async () => {
    // Add dynamic CSS for proper page breaks and consistent layout
    const style = document.createElement("style");
    style.innerHTML = `
      /* General styling */
      * {
        padding: 0px !important;
        margin: 0px !important;
        font-size: 15px !important;
        color: #000 !important;
        box-sizing: border-box; /* Maintain consistent sizing */
      }
  
      #inter-district-transfer-print {
        width: 100%;
      }
  
      /* Ensure each section prints on its own page */
      #inter-district-transfer-print > div {
        page-break-after: always; /* Force each child div to print on a new page */
        page-break-inside: avoid; /* Avoid breaking inside sections */
      }
  
      /* Table cell styling */
      #inter-district-transfer-print table tr td,
      #inter-district-transfer-print table tr th {
        padding: 3px 5px !important;
        border: 1px solid #000 !important;
        word-wrap: break-word; /* Prevent text overflow in cells */
      }
  
      /* Page setup */
      @page {
        size: A4; /* Set the page size to A4 */
        margin: 10mm 10mm 10mm 10mm !important; /* Set page margin */
      }
  
      @media print {
        body {
          margin: 0;
          padding: 0;
        }
  
        /* Hide unnecessary sections like buttons */
        #button-section {
          display: none;
        }
      }
    `;
    document.head.appendChild(style);

    // Get the #inter-district-transfer-print element
    const printContent = document.getElementById(
      "inter-district-transfer-print"
    );

    if (printContent) {
      // Clone the content for printing
      const printWrapper = document.createElement("div");
      printWrapper.id = "print-wrapper";

      // Clone each child element of #inter-district-transfer-print
      Array.from(printContent.children).forEach((child) => {
        const clone = child.cloneNode(true);
        printWrapper.appendChild(clone);
      });

      // Append the cloned content to the body
      document.body.appendChild(printWrapper);
      console.log(document.body.appendChild(printWrapper));

      // Trigger the print dialog
      window.print();

      // Clean up after printing
      document.body.removeChild(printWrapper);
      document.head.removeChild(style);
    } else {
      alert("No content available for printing.");
    }
  };

  return (
    <div className="container-xl py-3">
      <div
        id="inter-district-transfer-print"
        className="inter-district-transfer-print"
      >
        <div id="section1">
          <div class="text-end mb-4">
            <p>दिनांक :- </p>
          </div>
          <p class="fw-bold mb-1">प्रति,</p>
          <p class="fw-bold mb-1 ms-4">मा. मुख्य कार्यकारी अधिकारी,</p>
          <p class="fw-bold mb-4 ms-4">
            <b>{formData && formData.currentDistrict}</b>.
          </p>

          <p class="fw-bold mb-3">
            <strong>
              मार्फत :- {formData && formData.officerDesignation},{" "}
              {formData && formData.officeName},{" "}
              {formData && formData.currentDistrict}
            </strong>
          </p>
          <p class="fw-bold mb-4">
            <strong>विषय :-</strong> आंतर जिल्हा बदलीचा प्रस्ताव सादर करणे बाबत.
            <br />
          </p>
          <p class="fw-bold mb-3">आदरणीय महोदय,</p>
          <p className="mb-3 textIndent">
            उपरोक्त विषय विनंतीपूर्वक अर्ज सादर करतो की, मी दि{" "}
            <b>{formData && formData.appointmentDate}</b> पासून{" "}
            <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b> येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत आहे.
          </p>
          <p className="mb-3 textIndent">
            माझा मूळ जिल्हा हा <b>{formData && formData.district}</b> असून{" "}
            <b>{formData && formData.transferDistrict}</b> मध्ये आंतर जिल्हा
            बदली करण्यासाठी मी विहीत नमुन्यातील प्रस्ताव तीन प्रतीमध्ये यासोबत
            सादर करीत आहे.
          </p>
          <p className="mb-3 textIndent">
            कृपया माझा आंतर जिल्हा बदलीसाठी सन्मती प्रदान करावी, ही नम्र विनंती.
          </p>
          <div className="row mt-3 signatureText">
            <div className="col-lg-8 col-7"></div>
            <div className="col-lg-4 col-5">
              <div class="text-center">
                <p>आपला विश्वासू,</p>
                <div className="border-2 py-3"></div>
                <p className="fw-bold mb-0">{formData && formData.fullName}</p>
                <p className="fw-bold mb-0">
                  {formData && formData.designation}
                </p>
                <p className="fw-bold mb-0">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <p>
              <b>प्रतिलिपी :- </b>
            </p>
            <p className="ps-5">
              1. एक आगाऊ प्रत मा मुख्य कार्यकारी अधिकारी,{" "}
              <b>{formData && formData.transferDistrict}</b>, यांना देवून विनंती
              करण्यात येते की, कृपया मला{" "}
              <b>{formData && formData.transferDistrict}</b> मध्ये{" "}
              <b>{formData && formData.designation}</b> या पदावर आंतर जिल्हा
              बदलीने सामावून घ्यावे.
            </p>
            <p>हि नम्र विनंती.</p>
            <div className="row mt-3 signatureText">
              <div className="col-lg-8 col-7"></div>
              <div className="col-lg-4 col-5">
                <div class="text-center">
                  <p>आपला विश्वासू,</p>
                  <div className="border-2 py-3"></div>
                  <p className="fw-bold mb-0">
                    {formData && formData.fullName}
                  </p>
                  <p className="fw-bold mb-0">
                    {formData && formData.designation}
                  </p>
                  <p className="fw-bold mb-0">
                    {formData && formData.officeName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="section2">
          <div className="row">
            <div className="col-lg-9 col-8"></div>
            <div className="col-lg-3 col-4">
              <p>दिनांक :- </p>
            </div>
          </div>
          <p class="fw-bold mb-1">प्रति,</p>
          <p class="fw-bold mb-1 ms-4">मा. मुख्य कार्यकारी अधिकारी,</p>
          <p class="fw-bold mb-2 ms-4">
            <b>{formData && formData.transferDistrict}</b>.
          </p>
          <p class="fw-bold mb-2">
            <strong>विषय :-</strong> आंतर जिल्हा बदलीचा प्रस्ताव सादर करणे बाबत.
            <br />
          </p>
          <p className="mb-1 textIndent">
            मी <b> {formData && formData.fullName}</b>, विनंतीपूर्वक अर्ज सादर
            करतो की, मी <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b> येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून माझी
            सेवा <b>{formData && formData.transferDistrict}</b> कडे वर्ग करून
            देण्याबाबत खालील प्रमाणे माहिती सादर करण्यात येत आहे.
          </p>

          <table class="table table-bordered mt-2">
            <tbody>
              <tr>
                <th>१</th>
                <th>अर्जदाराचे पूर्ण नाव :</th>
                <td>
                  <b> {formData && formData.fullName}</b>
                </td>
              </tr>
              <tr>
                <th>२</th>
                <th>
                  सध्या अर्जदार काम करीत असलेल्या पदाचे व जिल्हा परिषदेचे नाव
                </th>
                <td>
                  {formData && formData.designation},{" "}
                  {formData && formData.officeName},{" "}
                  {formData && formData.currentDistrict}
                </td>
              </tr>
              <tr>
                <th>३</th>
                <th>
                  कोणत्या जिल्हा परिषदेत बदली करावयाची आहे त्या जि.प. चे नांव
                </th>
                <td>{formData && formData.transferDistrict}</td>
              </tr>
              <tr>
                <th>४</th>
                <th>कायम राहत असलेल्या गावाचे नांव व पत्ता</th>
                <td>{formData && formData.permanantAddress}</td>
              </tr>
              <tr>
                <th>५</th>
                <th>जन्मदिनांक अंकी व अक्षरी</th>
                <td>
                  {formData && formData.birthDateNumber}{" "}
                  {formData && formData.birthDateWords}
                </td>
              </tr>
              <tr>
                <th>६</th>
                <th>शैक्षणिक पात्रता</th>
                <td>{formData && formData.education}</td>
              </tr>
              <tr>
                <th>७</th>
                <th>कर्मचाऱ्याची जात व प्रवर्ग</th>
                <td>{formData && formData.casteCategory}</td>
              </tr>
              <tr>
                <th>८</th>
                <th>कर्मचाऱ्याचा सेवेचा तपशिल</th>
                <td>
                  {formData && formData.designation}{" "}
                  {formData && formData.appointmentDate} ते आजपर्यंत
                </td>
              </tr>
              <tr>
                <th>९</th>
                <th>सेवेत रुजू होण्याची तारीख</th>
                <td>
                  {formData && formData.designation}{" "}
                  {formData && formData.appointmentDate} ते आजपर्यंत
                </td>
              </tr>
              <tr>
                <th>१०</th>
                <th>सध्या धारण केलेले पद</th>
                <td>{formData && formData.currentPost}</td>
              </tr>
              <tr>
                <th>११</th>
                <th>सध्याची वेतनश्रेणी</th>
                <td>{formData && formData.salaryRange}</td>
              </tr>
              <tr>
                <th>१२</th>
                <th>सध्या घेत असलेले मूळ वेतन</th>
                <td>मूळवेतन {formData && formData.baseSalary}</td>
              </tr>
              <tr>
                <th>१३</th>
                <th>सध्या काम करीत असलेल्या पदाची नेमणूक तारीख</th>
                <td>
                  {formData && formData.currentPost},{" "}
                  {formData && formData.currentPostDate}
                </td>
              </tr>
              <tr>
                <th>१४</th>
                <th>
                  सध्याची नेमणूक ही कायम आहे किंवा तात्पुरती स्वरुपाची आहे
                </th>
                <td>{formData && formData.postType}</td>
              </tr>
              <tr>
                <th>१५</th>
                <th>
                  अर्जदारास भविष्य निर्वाह निधी व निवृत्ती वेतन योजना लागू आहे
                  काय
                </th>
                <td>{formData && formData.gpfApplicable}</td>
              </tr>
              <tr>
                <th>१६</th>
                <th>
                  अर्जदार हा भविष्य निर्वाह निधीचा वर्गणीदार आहे काय असल्यास
                  भनिनि क्र
                </th>
                <td>{formData && formData.gpfNumber}</td>
              </tr>
              <tr>
                <th>१७</th>
                <th>कोणत्या कारणासाठी आंतर जिल्हा बदलीचा अर्ज सादर केला आहे</th>
                <td>
                  <b>{formData && formData.transferReason}</b>
                </td>
              </tr>
            </tbody>
          </table>

          <p className="mb-1 textIndent">
            <b>{formData && formData.transferDistrict}ने</b> जिल्हा वर्गीकरण
            करीता ज्या अटी व नियम आहेत, ते मी वाचले असून मला ते मान्य आहे करीता
            सोबत संमतीपत्र सादर करीत आहे.
          </p>
          <div className="row mt-1 signatureText">
            <div className="col-lg-8 col-7"></div>
            <div className="col-lg-4 col-5">
              <div class="text-center">
                <p>आपला विश्वासू,</p>
                <div className="border-2 py-3"></div>
                <p className="fw-bold mb-0">{formData && formData.fullName}</p>
                <p className="fw-bold mb-0">
                  {formData && formData.designation}
                </p>
                <p className="fw-bold mb-0">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="section3">
          <h4
            class="text-center mb-3 fw-bold underline"
            style={{ fontSize: 18 }}
          >
            <b>{formData && formData.transferDistrict}ने</b> जिल्हा परिषद
            कर्मचाऱ्यांच्या आंतर जिल्हा बदलीबाबत ठरविलेल्या नियम व अटी
          </h4>
          <p className="mb-0">
            <b>1.</b> <b>{formData && formData.district}</b> जिल्हयाचे रहिवाशी
            असलेले परंतू दुसऱ्या जिल्हयात नौकरी करीत असलेले कर्मचारी यांना{" "}
            <b>{formData && formData.transferDistrict}</b> मध्ये वर्ग करुन
            घेण्यात येईल.
          </p>
          <p className="mb-0">
            <b>2.</b> बदली होवू इच्छिणारा कर्मचारी हा जिल्हा परिषद कर्मचारी हा
            त्या जिल्हापरिषदेमध्ये निवड मंडळामार्फत निवड होवू न नेमलेला असला
            पाहिजे.
          </p>
          <p className="mb-0">
            <b>3.</b> आवश्यक असल्यास व संबंधित अर्जदाराचे गोपनिय अभिलेखे
            सेवेबाबत माहिती घेवूनच बदली बाबत विचार करावा.
          </p>
          <p className="mb-0">
            <b>4.</b> महाराष्ट्र जिल्हा परिषद सेवा नियम १९६७ चे नियम ८८ मधील
            जेष्टता सुचीला असलेल्या तरतुदी नियमामध्ये वर्ग होणाऱ्या कर्मचाऱ्यास
            लागू असतील.
          </p>
          <p className="mb-0">
            <b>5.</b> <b>{formData && formData.transferDistrict}</b> मध्ये बदली
            होवून येणाऱ्या कर्मचाऱ्यांना जेष्ठतेच्या दृष्टीने नविन उमेदवार
            म्हणून संबोधण्यात येईल व त्याची जेष्ठता त्यावेळी आस्थापनेवर योग्य
            त्या जिल्हा परिषद कर्मचाऱ्याच्या सेवेच्या शेवटी घेण्यात येईल.
          </p>
          <p className="mb-0">
            <b>6.</b> जे जिल्हा परिषद कर्मचारी दुसऱ्या जिल्हयात आपली सेवा वर्ग
            करुन मागत असतील त्यांना त्या जिल्हा परिषदेचे मुख्य कार्यकारी अधिकारी
            ज्या अटीवर वर्ग करीत असतील त्या मान्य असतील तरच त्या जिल्हा परिषद
            कर्मचाऱ्याला दुसऱ्या जिल्हापरिषदेत वर्ग करण्याची परवानगी देण्यात
            येईल.
          </p>
          <p className="mb-0">
            <b>7.</b> <b>{formData && formData.transferDistrict}देत</b> वर्ग
            होवू इच्छिणाऱ्या इतर जिल्हा परिषद कर्मचाऱ्यांना जिल्हा परिषद{" "}
            <b>{formData && formData.district}</b> मध्ये जिल्हा परिषद
            कर्मचाऱ्यांच्या सेवांना केडरमध्ये किंवा पदोन्नतीमध्ये हिशोबात घेतली
            जाणार नाही.
          </p>
          <p className="mb-0">
            <b>8.</b> जिल्हा सेवेत बदली होवून येणाऱ्या कर्मचाऱ्यास नेमणूक अशा
            जागी दिली जाईल की, ज्या जागी नविन नेमणूकीने भरावयाची आहेत,
            पदोन्नतीने भरण्यात येणाऱ्या जागांवर त्यांना नेमणूक दिली जाणार नाही.
          </p>
          <p className="mb-0">
            <b>9.</b> आंतर जिल्हा बदली होवून येणाऱ्या कर्मचारी जर भविष्य निर्वाह
            निधी चा वर्गणीदार असेल तर त्याचे खात्यावर बदलून आलेल्या तारखेस
            त्याचे नावे जमा असलेली पूर्ण रक्कम व्याजासह आणि संस्थेच्या परिषदेत
            अथवा दुसऱ्या कोणत्याही निवृत्ती वेतन मिळणाऱ्या सेवेत बदली झाल्यास
            यथास्थिती द्यावी लागेल.
          </p>
          <p className="mb-0">
            <b>10.</b>पूर्वीच्या जिल्हा परिषद मध्ये कर्मचाऱ्यांची झालेली सेवा
            वर्ग होवून येणाऱ्या जिल्हा परिषद मध्ये रजा व निवृत्तीवेतन या
            बाबीकरीता विचारात घेतली जाईल.
          </p>
          <p className="mb-0">
            <b>11.</b> या जिल्हा परिषदेमध्ये वर्ग होवून येणाऱ्या जिल्हा वर्गवारी
            स्थानिक अथवा नियुक्तीचा प्रवासभत्ता{" "}
            <b>{formData && formData.transferDistrict}</b> कडून मिळणार नाही-
          </p>
          <p className="mb-0">
            <b>12.</b> या जिल्हा परिषदेमध्ये वर्ग होवून येणाऱ्या जिल्हा परिषद
            कर्मचाऱ्यांना ते ज्या जिल्हा परिषदेमधून वर्ग होवून येत आहेत त्या
            जिल्हापरिषदेकडून त्यांचे कोणतीही विरुध्द खाते चौकशी चालू अथवा
            प्रस्तावित नसल्याबाबतचे प्रमाणपत्र अर्जासोबत सादर करावे लागेल.
          </p>
          <p className="mb-0">
            <b>13.</b> दुसऱ्या जिल्हापरिषदेमधून{" "}
            <b>{formData && formData.transferDistrict}</b> मध्ये वर्ग होणाऱ्या
            कर्मचाऱ्याला काही पूर्वीच्या जिल्हापरिषदेकडे काही येणे असेल तर त्यास{" "}
            <b>{formData && formData.transferDistrict}</b> जबाबदार राहणार नाही
            तसेच त्यां चे कोणतेही दावे अथवा देय थकबाकी वर्ग होण्यापूर्वीचे
            असल्यास त्याबाबत <b>{formData && formData.transferDistrict}</b>{" "}
            जबाबदार राहणार नाही.
          </p>
          <p className="mb-0">
            <b>14.</b> बदली होवू इच्छिणाऱ्या कर्मचाऱ्याची बदली तो त्या जिल्हा
            परिषदमध्ये काम करीत असेल तेथील कोणत्याही थकबाकीसाठी त्या
            जिल्हापरिषदेची परवानगी असेल तरच ती विचारात घेण्यात येईल.
          </p>
          <p className="mb-0">
            <b>15.</b> अर्जदाराचे विनंतीनुसार त्यांचे स्थलांतर{" "}
            <b>{formData && formData.transferDistrict}</b>च्या विशिष्ठ ठिकाणी
            होईल अशी खात्री देता येणार नाही. जिल्हापरिषदेमध्ये रिक्त असलेल्या
            कोणत्याही ठिकाणी त्यांची नेमणूक होवू शकेल.या जिल्हापरिषदेमध्ये
            प्रशासकीय कारणास्तव कोठेही काम करावे लागेल.
          </p>
          <p className="mb-0">
            <b>16.</b> जिल्हा परिषद बदली बाबत जिल्हा परिषदेने तयार केलेले नियम व
            अटी माझ्यावर बंधनकारक राहतील.
          </p>
          <p className="mb-0">
            मी <b> {formData && formData.fullName}</b> असे लिहून देतो की, मी
            आंतर जिल्हा बदलीबाबतचे वरील नियम संपूर्ण वाचले असून मला ते पूर्णपणे
            मान्य आहेत. करीता मी स्वाक्षरी करीत आहे.
          </p>
          <div className="row mt-0 signatureText">
            <div className="col-lg-8 col-7"></div>
            <div className="col-lg-4 col-5">
              <div class="text-center">
                <div className="border-2 py-3"></div>
                <p className="fw-bold">{formData && formData.fullName}</p>
                <p className="fw-bold">{formData && formData.designation}</p>
                <p className="fw-bold">{formData && formData.officeName}</p>
              </div>
            </div>
          </div>
        </div>

        <div id="section4">
          <div className="row mb-5">
            <div className="col-lg-9 col-8"></div>
            <div className="col-lg-3 col-4">
              <p>दिनांक :- </p>
            </div>
          </div>
          <p class="fw-bold mb-1">प्रति,</p>
          <p class="fw-bold mb-1 ms-4">मा. मुख्य कार्यकारी अधिकारी,</p>
          <p class="fw-bold mb-3 ms-4">
            {formData && formData.transferDistrict}.
          </p>
          <p class="fw-bold mb-3">यांचे सेवेशी सविनय सादर...........</p>

          <p className="mb-3 textIndent">
            प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
            हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b>, येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
            विनंती पूर्वक लिहून देतो की, मी आपल्या{" "}
            <b>{formData && formData.transferDistrict}</b> मध्ये सामावून
            घेतल्यानंतर कोणत्याही तालुक्यात कोणत्याही ठिकाणी नौकरी करण्यात तयार
            आहे.
          </p>
          <p className="mb-3 textIndent">करीता संमतीपत्र लिहून देत आहे.</p>

          <div className="row mt-3 signatureText">
            <div className="col-lg-8 col-7"></div>
            <div className="col-lg-4 col-5">
              <div class="text-center">
                <p>आपला विश्वासू,</p>
                <div className="border-2 py-3"></div>
                <p className="fw-bold mb-0">{formData && formData.fullName}</p>
                <p className="fw-bold mb-0">
                  {formData && formData.designation}
                </p>
                <p className="fw-bold mb-0">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="section5">
          <h4
            class="text-center mb-4 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            जिल्हा परिषद कर्मचाऱ्याने आंतर जिल्हा बदलीसाठी करावयाचा अर्ज
          </h4>

          <table class="table table-bordered mt-4">
            <tbody>
              <tr>
                <th>१</th>
                <th>अर्जदाराचे पूर्ण नाव :</th>
                <td>
                  <b> {formData && formData.fullName}</b>
                </td>
              </tr>
              <tr>
                <th>२</th>
                <th>
                  सध्या अर्जदार काम करीत असलेल्या पदाचे व जिल्हा परिषदेचे नांव
                </th>
                <td>
                  <b>{formData && formData.designation}</b>,{" "}
                  <b>{formData && formData.officeName}</b>,{" "}
                  <b>{formData && formData.currentDistrict}</b>
                </td>
              </tr>
              <tr>
                <th>३</th>
                <th>
                  कोणत्या जिल्हा परिषदेकडे बदली करावयाची आहे व त्या जि. प. चे
                  नांव
                </th>
                <td>{formData && formData.transferDistrict}</td>
              </tr>
              <tr>
                <th>४</th>
                <th>कायम राहत असलेल्या गावाचे नांव व पत्ता</th>
                <td>{formData && formData.permanantAddress}</td>
              </tr>
              <tr>
                <th>५</th>
                <th>जन्मदिनांक अंकी व अक्षरी</th>
                <td>
                  {formData && formData.birthDateNumber} <br />
                  {formData && formData.birthDateWords}
                </td>
              </tr>

              <tr>
                <th>६</th>
                <th>शैक्षणिक पात्रता</th>
                <td>{formData && formData.education}</td>
              </tr>
              <tr>
                <th>७</th>
                <th>कर्मचाऱ्याची जात व प्रवर्ग</th>
                <td>{formData && formData.casteCategory}</td>
              </tr>
              <tr>
                <th>८</th>
                <th>कर्मचाऱ्याचा सेवेचा तपशिल</th>
                <td>
                  {formData && formData.designation}{" "}
                  {formData && formData.appointmentDate} ते आजपर्यंत
                </td>
              </tr>
              <tr>
                <th>९</th>
                <th>सेवेत रुजू होण्याची तारीख</th>
                <td>
                  {formData && formData.designation}{" "}
                  {formData && formData.appointmentDate} ते आजपर्यंत
                </td>
              </tr>
              <tr>
                <th>१०</th>
                <th>सध्या धारण केलेले पद</th>
                <td>{formData && formData.currentPost}</td>
              </tr>
              <tr>
                <th>११</th>
                <th>सध्याची वेतनश्रेणी </th>
                <td>{formData && formData.salaryRange}</td>
              </tr>
              <tr>
                <th>१२</th>
                <th>सध्या घेत असलेले मूळ वेतन</th>
                <td>मूळवेतन {formData && formData.baseSalary}</td>
              </tr>
              <tr>
                <th>१३</th>
                <th>सध्या काम करीत असलेल्या पदाची नेमणूक तारीख</th>
                <td>
                  {formData && formData.currentPost}{" "}
                  {formData && formData.currentPostDate}
                </td>
              </tr>
              <tr>
                <th>१४</th>
                <th>
                  सध्याची नेमणूक ही कायम आहे किंवा तात्पुरती स्वरुपाची आहे
                </th>
                <td>{formData && formData.postType}</td>
              </tr>
              <tr>
                <th>१५</th>
                <th>
                  अर्जदारास भविष्य निर्वाह निधी व निवृत्ती वेतन योजना लागू आहे
                  काय
                </th>
                <td>{formData && formData.gpfApplicable}</td>
              </tr>
              <tr>
                <th>१६</th>
                <th>
                  अर्जदार हा भविष्य निर्वाह निधीचा वर्गणीदार आहे काय असल्यास
                  भनिनि क्र
                </th>
                <td>{formData && formData.gpfNumber}</td>
              </tr>
              <tr>
                <th>१७</th>
                <th>कोणत्या कारणासाठी आंतर जिल्हा बदलीचा अर्ज सादर केला आहे</th>
                <td>
                  <b>{formData && formData.transferReason}</b>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="row mt-3 signatureText">
            <div className="col-lg-8 col-7"></div>
            <div className="col-lg-4 col-5">
              <div class="text-center">
                <p>आपला विश्वासू,</p>
                <div className="border-2 py-3"></div>
                <p className="fw-bold mb-0">{formData && formData.fullName}</p>
                <p className="fw-bold mb-0">
                  {formData && formData.designation}
                </p>
                <p className="fw-bold mb-0">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="section6">
          <h4
            class="text-center mb-3 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            स्थानांतर मागणाऱ्या जिल्हा परिषद कर्मचाऱ्यांनी भरुन द्यावयाचे
            संमतीपत्र
          </h4>
          <p class="mb-3 textIndent ">
            मी, <b> {formData && formData.fullName}</b>,{" "}
            <b>{formData && formData.currentDistrict}</b> अंतर्गत,{" "}
            <b>{formData && formData.officeName}</b>, येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून{" "}
            <b>{formData && formData.transferDistrict}</b> कडे माझी सेवा वर्ग
            करुन घेण्याकरीता अर्ज केला आहे. याबाबत महाराष्ट्र जिल्हा परिषद
            जिल्हा सेवा प्रवेश नियम १९६७ नियम ६ (८) अन्वये मा. मुख्य कार्यकारी
            अधिकारी, जिल्हा परिषद यांनी इतर जिल्हा बदली संबंधी ज्या अटी व नियम
            ठरविले आहेत ते सर्व नियम मला मान्य आहेत. त्यांनी ठरविलेल्या
            नियमानुसार व शर्तीनुसार मी ज्या तारखेपासून{" "}
            <b>{formData && formData.transferDistrict}</b> मध्ये समाविष्ठ केला
            जाईल, त्या तारखेपासून <b>{formData && formData.transferDistrict}</b>{" "}
            कर्मचाऱ्यांच्या नौकरीतील सेवा जेष्ठता ठरविली जाईल. वेतन व निवृत्ती
            वेतन आणि रजा या बाबतीत इतर जिल्हयात झालेल्या नियमाप्रमाणे धरण्यात
            येणारी सर्व सेवा विचारात घेतली जाईल. या अटी मला पूर्णपणे व निश्चित
            मान्य असून त्याबाबत माझी कोणत्याही प्रकारची तक्रार नाही. व यापुढेही
            भविष्यात मी काहीही तक्रार करणार नाही.
          </p>
          <p class="mb-3 textIndent ">करिता संमतीपत्र लिहून देत आहे.</p>
          <div class="mb-4 fw-bold">
            <p>दिनांक :- </p>
          </div>
          <div className="row mt-2 signatureText">
            <div className="col-lg-8 col-7"></div>
            <div className="col-lg-4 col-5">
              <div class="text-center">
                <div className="border-2 py-3"></div>
                <p className="fw-bold mb-0">{formData && formData.fullName}</p>
                <p className="fw-bold mb-0">
                  {formData && formData.designation}
                </p>
                <p className="fw-bold mb-0">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6"></div>
          </div>
          <div class="pt-5 mt-3">
            <h4
              class="text-center mb-4 fw-bold underline"
              style={{ fontSize: 20 }}
            >
              भविष्य निर्वाह निधी वर्ग करण्याबाबत संमतीपत्र
            </h4>
            <p class="mb-3 textIndent ">
              नी, <b> {formData && formData.fullName}</b>,{" "}
              <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
              <b>{formData && formData.officeName}</b>, येथे{" "}
              <b>{formData && formData.designation}</b> या पदावर कार्यरत असून,
              माझी नेमणूक <b>{formData && formData.designation}</b> या पदावर
              दिनांक <b>{formData && formData.appointmentDate}</b> रोजी{" "}
              <b>{formData && formData.firstAppointmentOffice}</b> येथे
              प्रथमसमयी रुजू झालो आहे. तसेच{" "}
              <b>{formData && formData.officeName}</b> या कार्यालयात दिनांक{" "}
              <b>{formData && formData.currentPostDate}</b> रोजी हजर झालो आहे.
            </p>
            <p class="mb-3 textIndent ">
              माझा भविष्य निर्वाह निधी खाते क्र{" "}
              <b>{formData && formData.gpfNumber}</b> हा असून सदरील खाते व
              खात्यावरील आज रोजी जमा असलेली रक्कम{" "}
              <b>{formData && formData.transferDistrict}</b> कडे वर्ग करण्यास
              माझी काहीही हरकत नाही. करीता संमतीपत्र लिहून देत आहे.
            </p>
            <div class="mb-4 fw-bold">
              <p>दिनांक :- </p>
            </div>
            <div className="row mt-3 signatureText">
              <div className="col-lg-8 col-7"></div>
              <div className="col-lg-4 col-5">
                <div class="text-center">
                  <div className="border-2 py-3"></div>
                  <p className="fw-bold mb-0">
                    {formData && formData.fullName}
                  </p>
                  <p className="fw-bold mb-0">
                    {formData && formData.designation}
                  </p>
                  <p className="fw-bold mb-0">
                    {formData && formData.officeName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="section7">
          <h4
            class="text-center mb-4 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            ना मागणी प्रमाणपत्र
          </h4>
          <p class="mb-3 textIndent ">
            मे, <b> {formData && formData.fullName}</b>,{" "}
            <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b>, येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
            प्रतिज्ञापूर्वक लिहून देतो की, माझी बदली{" "}
            <b>{formData && formData.transferDistrict}</b> येथे झाल्यास मी माझी
            बदली रद्द करण्याबाबत कोणतीही मागणी करणार नाही, तसेच याबाबत कोणत्याही
            प्रकारची तक्रार करणार नाही.
          </p>
          <p class="mb-3 textIndent ">करीता प्रतिज्ञापत्र लिहून देत आहे.</p>
          <div class="mb-4 fw-bold">
            <p>दिनांक :- </p>
          </div>
          <div className="row mt-3 signatureText">
            <div className="col-lg-8 col-7"></div>
            <div className="col-lg-4 col-5">
              <div class="text-center">
                <div className="border-2 py-3"></div>
                <p className="fw-bold mb-0">{formData && formData.fullName}</p>
                <p className="fw-bold mb-0">
                  {formData && formData.designation}
                </p>
                <p className="fw-bold mb-0">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>

          <div class="pt-5 mt-5">
            <h4
              class="text-center mb-4 fw-bold underline"
              style={{ fontSize: 20 }}
            >
              जिल्हयात कोठेही काम करण्याबाबत संमतीपत्र
            </h4>
            <p class="mb-3 textIndent ">
              मी. <b> {formData && formData.fullName}</b>,{" "}
              <b>{formData && formData.currentDistrict}</b> अंतर्गत,{" "}
              <b>{formData && formData.officeName}</b>, येथे{" "}
              <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
              प्रतिज्ञापूर्वक लिहून देतो की. माझी बदली{" "}
              <b>{formData && formData.transferDistrict}</b> येथे झाल्यास त्या
              जिल्हा परिषदेतील <b>{formData && formData.designation}</b> या
              संवर्गातील सर्व कार्यरत कर्मचाऱ्यांच्या नंतरची सेवा जेष्ठता मला
              देण्यात येईल. जिल्हा बदली झाल्यास {formData && formData.district}{" "}
              जिल्हयात कोणत्याही तालुक्यात माझी नेमणूक झाल्यास मी तेथे काम
              करण्यास तयार आहे.
            </p>
            <p class="mb-3 textIndent ">करीता प्रतिज्ञापत्र लिहून देत आहे.</p>

            <div class="mb-3 fw-bold">
              <p>दिनांक :- </p>
            </div>
            <div className="row mt-3 signatureText">
              <div className="col-lg-8 col-7"></div>
              <div className="col-lg-4 col-5">
                <div class="text-center">
                  <div className="border-2 py-3"></div>
                  <p className="fw-bold mb-0">
                    {formData && formData.fullName}
                  </p>
                  <p className="fw-bold mb-0">
                    {formData && formData.designation}
                  </p>
                  <p className="fw-bold mb-0">
                    {formData && formData.officeName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="section8">
          <h4
            class="text-center mb-4 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            खाते चौकशी बाबत प्रमाणपत्र
          </h4>
          <p class="mb-3 textIndent ">
            प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
            हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b>, येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
            त्यांचे विरुध्द कोणत्याही प्रकारची खातेचौकशी / विभागीय चौकशी सुरु
            अथवा भविष्यात सुरु करण्याचे प्रस्तावित नाही.{" "}
          </p>
          <p class="mb-3 textIndent ">
            करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
            <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
            कामासाठी देण्यात येत आहे.
          </p>
          <div class="mb-3 fw-bold">
            <p>दिनांक :- </p>
          </div>

          <div class="row mt-5 signatureText">
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.officerDesignation} <br />
                  {formData && formData.officeName}
                </b>
              </p>
            </div>
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.hodDesignation}
                  <br />
                  {formData && formData.currentDistrict}
                </b>
              </p>
            </div>
          </div>

          <div class="pt-5 mt-5">
            <h4
              class="text-center mb-4 fw-bold underline"
              style={{ fontSize: 20 }}
            >
              न्यायालयीन चौकशी प्रमाणपत्र
            </h4>
            <p class="mb-3 textIndent ">
              प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
              हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
              <b>{formData && formData.officeName}</b>, येथे{" "}
              <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
              त्यांचे विरुध्द कोणत्याही प्रकारची न्यायालयीन चौकशी सुरु नाही अथवा
              प्रस्तावित करण्याची गरज वाटत नाही
            </p>
            <p class="mb-3 textIndent ">
              करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
              <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
              कामासाठी देण्यात येत आहे.
            </p>
            <div class="mb-3 fw-bold">
              <p>दिनांक :- </p>
            </div>

            <div class="row mt-5 signatureText">
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.officerDesignation} <br />
                    {formData && formData.officeName}
                  </b>
                </p>
              </div>
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.hodDesignation}
                    <br />
                    {formData && formData.currentDistrict}
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="section9">
          <h4
            class="text-center mb-4 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            ना देय प्रमाणपत्र
          </h4>
          <p class="mb-3 textIndent ">
            प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b> हे{" "}
            <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b>, येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
            त्यांचेकडून आज रौजी कोणत्याही प्रकारचे अग्रीम रक्कम अथवा शासकीय येणे
            बाकी नाही.
          </p>
          <p class="mb-3 textIndent ">
            करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
            <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
            कामासाठी देण्यात येत आहे.
          </p>
          <div class="mb-3 fw-bold">
            <p>दिनांक :- </p>
          </div>
          <div class="row mt-5 signatureText">
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.officerDesignation} <br />
                  {formData && formData.officeName}
                </b>
              </p>
            </div>
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.hodDesignation}
                  <br />
                  {formData && formData.currentDistrict}
                </b>
              </p>
            </div>
          </div>

          <div class="pt-5 mt-5">
            <h4
              class="text-center mb-4 fw-bold underline"
              style={{ fontSize: 20 }}
            >
              वर्तणूकीबाबत प्रमाणपत्र
            </h4>
            <p class="mb-3 textIndent ">
              प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
              हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
              <b>{formData && formData.officeName}</b>, येथे{" "}
              <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
              त्यांची वर्तणूक चांगली आहे.
            </p>
            <p class="mb-3 textIndent ">
              करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
              <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
              कामासाठी देण्यात येत आहे.
            </p>

            <div class="mb-3 fw-bold">
              <p>दिनांक :- </p>
            </div>

            <div class="row mt-5 signatureText">
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.officerDesignation}
                    <br />
                    {formData && formData.officeName}
                  </b>
                </p>
              </div>
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.hodDesignation}
                    <br />
                    {formData && formData.currentDistrict}
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="section10">
          <h4
            class="text-center mb-4 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            नियुक्ती बाबत प्रमाणपत्र
          </h4>
          <p class="mb-3 textIndent ">
            प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>{" "}
            यांची प्रथम नेमणूक{" "}
            <b>{formData && formData.firstAppointmentOffice}</b> या कार्यालयात{" "}
            <b>{formData && formData.appointmentDate}</b> रोजी{" "}
            <b>{formData && formData.firstAppointmentDesig}</b> या पदावर झालेली
            असून सध्या <b>{formData && formData.fullName}</b> हे{" "}
            <b>{formData && formData.officeName}</b> या कार्यालयात{" "}
            <b>{formData && formData.currentPost}</b> या पदावर{" "}
            <b>{formData && formData.currentPostDate}</b> या दिनांकापासून
            कार्यरत आहेत.
          </p>
          <p class="mb-3 textIndent ">
            करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
            <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
            कामासाठी देण्यात येत आहे.
          </p>
          <div class="mb-3 fw-bold">
            <p>दिनांक :- </p>
          </div>
          <div class="row mt-5 signatureText">
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.officerDesignation} <br />
                  {formData && formData.officeName}
                </b>
              </p>
            </div>
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.hodDesignation}
                  <br />
                  {formData && formData.currentDistrict}
                </b>
              </p>
            </div>
          </div>

          <div class=" pt-5 mt-5">
            <h4
              class="text-center mb-4 fw-bold underline"
              style={{ fontSize: 20 }}
            >
              सेवापुस्तिकेबाबत प्रमाणपत्र
            </h4>
            <p class="mb-3 textIndent ">
              प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
              हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
              <b>{formData && formData.officeName}</b>,
              <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
              त्यांचे मूळ सेवापुस्तिका तयार केलेले आहे. सदर सेवापुस्तिकेत
              नेमणूकीपासून सर्व नोंदी घेतलेल्या असून प्रमाणित करण्यात आलेल्या
              आहेत.
            </p>
            <p class="mb-3 textIndent ">
              करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
              <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
              कामासाठी देण्यात येत आहे..
            </p>
            <div class="mb-3 fw-bold">
              <p>दिनांक :- </p>
            </div>

            <div class="row mt-5 signatureText">
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.officerDesignation}
                    <br />
                    {formData && formData.officeName}
                  </b>
                </p>
              </div>
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.hodDesignation}
                    <br />
                    {formData && formData.currentDistrict}
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="section11">
          <h4
            class="text-center mb-4 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            नियमित सेवा प्रमाणपत्र
          </h4>
          <p class="mb-3 textIndent ">
            प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
            हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b>, येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
            त्यांची प्रथम नेमणूक{" "}
            <b>{formData && formData.firstAppointmentDesig}</b> या पदावर दिनांक{" "}
            {formData && formData.appointmentDate} रोजी नियुक्ती देण्यात आलेली
            आहे. तसेच त्यांची आजपर्यंतची सेवा विनाखंड नियमित झालेली आहे.
          </p>
          <p class="mb-3 textIndent ">
            करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
            <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
            कामासाठी देण्यात येत आहे.
          </p>
          <div class="mb-3 fw-bold">
            <p>दिनांक :- </p>
          </div>
          <div class="row signatureText">
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.officerDesignation} <br />
                  {formData && formData.officeName}
                </b>
              </p>
            </div>
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.hodDesignation}
                  <br />
                  {formData && formData.currentDistrict}
                </b>
              </p>
            </div>
          </div>

          <div class=" pt-5 mt-5">
            <h4
              class="text-center mb-4 fw-bold underline"
              style={{ fontSize: 20 }}
            >
              सेवा व जन्मतारीख पडताळणी प्रमाणपत्र
            </h4>
            <p class="mb-3 textIndent ">
              प्रमाणित करण्यात येते की. <b> {formData && formData.fullName}</b>,
              हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
              <b>{formData && formData.officeName}</b>, येथे{" "}
              <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
              त्यांची प्रथम नेमणूक{" "}
              <b>{formData && formData.firstAppointmentDesig}</b> या पदावर
              दिनांक <b>{formData && formData.appointmentDate}</b> रोजी{" "}
              <b>{formData && formData.firstAppointmentOffice}</b>,{" "}
              <b>{formData && formData.currentDistrict}</b> येथे रुजू झालेले
              आहेत. त्यांची मूळ सेवापुस्तिकेवरुन त्यांची दि{" "}
              <b>{formData && formData.appointmentDate}</b> ते{" "}
              <b>{moment().format("DD-MMM-YYYY")}</b> पर्यंतची सेवापडताळणी वेतन
              देयकाप्रमाणे करण्यात आलेली आहे. तसेच मूळ सेवापुस्तिकेत
              दर्शविल्याप्रमाणे (शाळा सोडल्याच्या प्रमाणपत्रानुसार) त्यांची
              जन्मतारीख <b>{formData && formData.birthDateNumber}</b> (
              <b>{formData && formData.birthDateWords}</b>) अशी नोंदवून प्रमाणित
              करण्यात आलेली आहे. करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
              <b> {formData && formData.fullName}</b>
              यांना आंतर जिल्हा बदली कामासाठी देण्यात येत आहे.
            </p>

            <div class="mb-3 fw-bold">
              <p>दिनांक :- </p>
            </div>

            <div class="row mt-5 signatureText">
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.officerDesignation}
                    <br />
                    {formData && formData.officeName}
                  </b>
                </p>
              </div>
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.hodDesignation}
                    <br />
                    {formData && formData.currentDistrict}
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="section12">
          <h4
            class="text-center mb-3 fw-bold underline"
            style={{ fontSize: 20 }}
          >
            वैद्यकीय दृष्टया काम करण्यास पात्र असल्याबाबतचे प्रमाणपत्र
          </h4>
          <p class="mb-3 textIndent ">
            प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
            हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
            <b>{formData && formData.officeName}</b>, येथे{" "}
            <b>{formData && formData.designation}</b> या पदावर कार्यरत असून हे{" "}
            <b>{formData && formData.designation}</b> या पदावर वैद्यकीय दृष्टया
            काम करण्यास पात्र आहेत.
          </p>
          <p class="mb-3 textIndent ">
            करीता प्रमाणित करण्यात येते. सदरील प्रमाणपत्र{" "}
            <b> {formData && formData.fullName}</b> यांना आंतर जिल्हा बदली
            कामासाठी देण्यात येत आहे.
          </p>
          <div class="mb-3 fw-bold">
            <p>दिनांक :- </p>
          </div>
          <div class="row signatureText">
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.officerDesignation} <br />
                  {formData && formData.officeName}
                </b>
              </p>
            </div>
            <div class="col-lg-6 col-6 text-center">
              <p>
                <b>
                  {formData && formData.hodDesignation}
                  <br />
                  {formData && formData.currentDistrict}
                </b>
              </p>
            </div>
          </div>

          <div class="pt-3 mt-4">
            <h4
              class="text-center mb-3 fw-bold underline"
              style={{ fontSize: 20 }}
            >
              वेतन प्रमाणपत्र
            </h4>

            <p class="mb-3 textIndent ">
              प्रमाणित करण्यात येते की, <b> {formData && formData.fullName}</b>,
              हे <b>{formData && formData.currentDistrict}</b> अंतर्गत{" "}
              <b>{formData && formData.officeName}</b>, येथे{" "}
              <b>{formData && formData.designation}</b> या पदावर कार्यरत असून
              त्यांचे माहे {salarySlip && salarySlip.salaryDate} चे मासिक वेतन
              खालील प्रमाणे आहे.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Left Column */}
              <table className="table-auto border-collapse border border-gray-300 w-full">
                <thead>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2">
                      देय वेतन
                    </th>
                    <th className="border border-gray-300 px-4 py-2">रक्कम</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { label: "मूळ वेतन", name: "basicPay" },
                    { label: "महागाई भत्ता", name: "dearnessAllowance" },
                    { label: "घरभाडे", name: "houseRentAllowance" },
                    { label: "वाहतूक भत्ता", name: "transportAllowance" },
                    { label: "शहर भत्ता", name: "cityAllowance" },
                    { label: "NPS", name: "nps" },
                    { label: "महागाई भत्ता फरक", name: "dearnessDifference" },
                    { label: "Other-1", name: "other1" },
                    {
                      label: "एकूण देय वेतन",
                      name: "grossPayableSalary",
                      isHighlighted: true,
                    },
                  ].map(({ label, name, isHighlighted }) => (
                    <tr key={name}>
                      <td
                        className={`border border-gray-300 px-4 py-2 font-semibold ${
                          isHighlighted ? "text-red-600" : ""
                        }`}
                      >
                        {label}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {name === "grossPayableSalary" ? (
                          <b>{salarySlip && salarySlip.grossPayableSalary}</b>
                        ) : (
                          salarySlip && salarySlip[name]
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Right Column */}
              <table className="table-auto border-collapse border border-gray-300 w-full">
                <thead>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2">कपात</th>
                    <th className="border border-gray-300 px-4 py-2">रक्कम</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { label: "व्यवसाय कर", name: "professionTax" },
                    { label: "गट विमा", name: "groupInsurance" },
                    { label: "भ.नि.नि. वर्गणी", name: "bhininiVargani" },
                    { label: "सण अग्रिम", name: "festivalAdvance" },
                    { label: "DCPS", name: "dcps" },
                    { label: "NPS (कपात)", name: "npsDeduction" },
                    { label: "एल आय सी", name: "lic" },
                    { label: "जी प पतसंस्था", name: "gppatSanstha" },
                    { label: "रशीद तिकीट", name: "receiptTicket" },
                    {
                      label: "एकूण कपात वेतन",
                      name: "totalDeductions",
                      isHighlighted: true,
                    },
                    {
                      label: "निव्वळ देय वेतन",
                      name: "netPaySalary",
                      isHighlighted: true,
                    },
                  ].map(({ label, name, isHighlighted }) => (
                    <tr key={name}>
                      <td
                        className={`border border-gray-300 px-4 py-2 font-semibold ${
                          isHighlighted ? "text-red-600" : ""
                        }`}
                      >
                        {label}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {name === "netPaySalary" ? (
                          <b>{salarySlip && salarySlip.netPaySalary}</b>
                        ) : name === "totalDeductions" ? (
                          <b>{salarySlip && salarySlip.totalDeductions}</b>
                        ) : (
                          salarySlip && salarySlip[name]
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="fw-bold mb-2">
              निव्वळ देय वेतन :- {salarySlip && salarySlip.netPaySalary}/-
            </p>
            <p className="fw-bold mb-2">
              भविष्य निर्वाह निधी खाते क्रमांक:-{" "}
              {formData && formData.gpfNumber}
            </p>
            <div class="row mt-5 signatureText">
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.officerDesignation} <br />
                    {formData && formData.officeName}
                  </b>
                </p>
              </div>
              <div class="col-lg-6 col-6 text-center">
                <p>
                  <b>
                    {formData && formData.hodDesignation}
                    <br />
                    {formData && formData.currentDistrict}
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row my-4" id="button-section">
        <div className="col-lg-4 m-auto">
          <button
            className="btn btn-primary btn-lg"
            onClick={() => generatePrintablePage()}
          >
            Print
          </button>
          <button
            className="btn btn-danger btn-lg"
            onClick={() => navigate("/dashboard/inter_district_transfer_work")}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterDistrictTransferPrint;
